import gql from "graphql-tag";

export const addBranchM = gql`
    mutation AddBranch(
        $name: String!
    ){
        addBranch(
            name: $name
        ) {
            _id,
            name
        }
    }
`;

export const updateBranchM = gql`
    mutation UpdateBranch(
        $_id: ID!,
        $name: String!
    ){
        updateBranch(
            _id: $_id,
            name: $name
        ) {
            _id,
            name
        }
    }
`;

export const removeBranchM = gql`
    mutation RemoveBranch(
        $_id: ID!
    ){
        removeBranch(
            _id: $_id
        ) {
            _id,
            name,
        }
    }
`;


// WEBPACK FOOTER //
// ./src/graphql/mutation/branch.js